import { createStyles } from "@material-ui/styles";
import { makeStyles } from "@saleor/macaw-ui";

const useStyles = makeStyles(
  theme =>
    createStyles({
      root: {
        width: "100%",
        padding: "0px"
      },
      paper: {
        width: "100% !important",
        padding: "0 !important",
        maxWidth: "100% !important",
        marginBottom: theme.spacing(2),
        borderRadius: "0 !important",
        boxShadow: "none"
      },
      table: {
        minWidth: "100%",
        maxWidth: "100%",
        boxShadow: "none",
        border: "none",
        display: "block"
      },
      tabHeadBg: {
        background: "#ffffff !important",
        border: "none !important",
        paddingRight: "10px"
      },

      tabBodyPad: {
        padding: "0px !important",
        border: "none !important",
        display: "flex",
        "&:first-child": {
          width: "47px !important"
        },
        "tr th": {
          border: "none"
        }
      },
      radioCell: {
        width: "50px !important",
        background: "#ffffff !important",
        padding: "0px !important",
        border: "none !important"
      },

      sortIcon: {
        marginLeft: "-40px",
        color: "#009FB8",
        "& svg": {
          width: "16px",
          height: "16px",
          color: "#009FB8 !important"
        }
      },
      sortLabel: {
        color: "#009FB8",
        width: "16px",
        height: "16px"
      },
      bodyScroll: {
        overflow: "auto",
        maxHeight: "300px",
        display: "block",
        border: "1px solid #E0E0E0",
        "MuiTableRow-hover:hover": {
          background: "transparent !important"
        }
      },
      blockedDisplay: {
        display: "block"
      },
      flexDisplay: {
        display: "flex",
        maxHeight: "100%",
        alignItems: "center",
        "&:hover": {
          background: "#ffffff",
          "&:before": {
            display: "none !important"
          }
        },
        "&:nth-child(even)": {
          background: "transparent !important"
        }
      },
      noBorder: {
        border: "none !important",
        display: "flex",
        alignItems: "center",

        whiteSpace: "nowrap",
        fontWeight: 500
      }
    }),
  { name: "DataSortTableStyles" }
);
export default useStyles;
